<template>
  <LoadingSpinner v-if="loadingPage" />
  <div v-else class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-header pb-0">
            <div class="d-flex justify-content-center align-items-center">
              <div class="col-md-6"><h6>Clientes</h6></div>
              <div class="col-md-6 text-end">
                <router-link
                  :to="{ name: 'crear-cliente' }"
                  class="btn bg-gradient-primary btn-xs"
                >
                  <i class="ri-add-line me-1"></i>
                  Nuevo cliente</router-link
                >
              </div>
            </div>
          </div>
          <div class="card-body px-0 pt-0 pb-2 vh-50">
            <div class="table-responsive p-0">
              <table class="table align-items-center mb-0">
                <thead>
                  <tr>
                    <th
                      class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                    >
                      Cliente
                    </th>
                    <th
                      class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                    >
                      Empresa
                    </th>
                    <th
                      class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                    >
                      Celular
                    </th>
                    <th
                      class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                    >
                      Teléfono
                    </th>
                    <th
                      class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2"
                    >
                      Residencia
                    </th>
                    <th
                      class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                    >
                      Estatus
                    </th>
                    <th class="text-secondary opacity-7"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="cliente in clientes.data" :key="cliente.id">
                    <td>
                      <div class="d-flex px-2 py-1">
                        <div>
                          <img
                            src="https://img.freepik.com/free-icon/team_318-411397.jpg"
                            class="avatar avatar-sm me-3"
                            alt="user6"
                          />
                        </div>
                        <div class="d-flex flex-column justify-content-center">
                          <h6 class="mb-0 text-sm text-lowercase">
                            {{ cliente.nombre }} {{ cliente.paterno }}
                            {{ cliente.materno }}
                          </h6>
                          <p class="text-xs text-secondary mb-0">
                            {{ cliente.correo }}
                          </p>
                        </div>
                      </div>
                    </td>
                    <td class="align-middle">
                      <span class="text-secondary text-xs font-weight-bold">
                        <h6 class="mb-0 text-sm text-lowercase">
                          {{ cliente.empresa }}
                        </h6>
                        <p class="text-xs text-lowercase text-secondary mb-0">
                          Persona {{ cliente.tipo_persona }}
                        </p>
                      </span>
                    </td>
                    <td class="align-middle">
                      <span class="text-secondary text-xs font-weight-bold">{{
                        cliente.celular
                      }}</span>
                    </td>
                    <td class="align-middle">
                      <span class="text-secondary text-xs font-weight-bold">{{
                        cliente.telefono
                      }}</span>
                    </td>
                    <td>
                      <p class="text-xs font-weight-bold mb-0">
                        {{ cliente.municipio }}
                      </p>
                      <p class="text-xs text-secondary mb-0">
                        {{ cliente.estado }}
                      </p>
                    </td>
                    <td class="align-middle text-center text-sm">
                      <span
                        v-if="cliente.activo"
                        class="badge badge-sm bg-gradient-success"
                        >Activo</span
                      >
                      <span v-else class="badge badge-sm bg-gradient-danger"
                        >Inactivo</span
                      >
                    </td>
                    <td class="align-middle text-center">
                      <div class="dropdown">
                        <button
                          class="btn btn-link text-secondary dropdown-toggle btn-xs p-0"
                          type="button"
                          id="dropdownMenuButton1"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                        >
                          <i class="ri-settings-line me-1"></i>
                          Acciones
                        </button>
                        <ul
                          class="dropdown-menu"
                          aria-labelledby="dropdownMenuButton1"
                        >
                          <li>
                            <router-link
                              :to="{
                                name: 'editar-cliente',
                                params: { cliente_id: cliente.id },
                              }"
                              class="dropdown-item"
                            >
                              <i class="ri-pencil-line me-1"></i>
                              Modificar
                            </router-link>
                          </li>
                          <li>
                            <button
                              class="dropdown-item"
                              @click="updateEstatus(cliente.activo, cliente.id)"
                            >
                              <i class="ri-shut-down-line me-1"></i>
                              {{ textoActivacion(cliente.activo) }}
                            </button>
                          </li>
                        </ul>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
              <div class="col-12 px-4">
                <PaginationComponent
                  :current-page="clientes.current_page"
                  :last-page="clientes.last_page"
                  @page-change="getClientes"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import appApi from "@/services/api";
import LoadingSpinner from "@/components/LoadingComponent.vue";
import { showToast, exceptionRequestMsg } from "@/assets/js/util";
import PaginationComponent from "@/components/PaginationComponent";

export default {
  name: "clientes",
  components: {
    LoadingSpinner,
    PaginationComponent,
  },
  data() {
    return {
      clientes: {},
      loadingPage: true,
    };
  },
  methods: {
    async getClientes(page = 1) {
      this.loadingPage = true;
      const response = await appApi().get(`clientes?page=${page}`);
      this.clientes = response.data;
      this.loadingPage = false;
    },
    textoActivacion(activo) {
      return activo ? "Desactivar" : "Activar";
    },
    async updateEstatus(activo, cliente) {
      this.loadingPage = true;
      const nuevoEstatus = activo ? 0 : 1;
      const formData = new FormData();
      formData.append("estatus", nuevoEstatus);
      formData.append("_method", "PUT");
      try {
        const response = await appApi().post(
          `clientes/update/estatus/${cliente}`,
          formData
        );

        const { status, message } = response.data;

        if (!status) {
          showToast(message, "error");
          this.loadingPage = false;
          return;
        }

        await this.getClientes();
        this.loadingPage = false;
        showToast(message, "success");
      } catch (e) {
        this.loadingPage = false;
        exceptionRequestMsg(e);
      }
    },
  },
  created() {
    this.getClientes();
  },
};
</script>

<style>
@media (max-width: 767px) {
  .table-responsive .dropdown-menu {
    position: static !important;
  }
}
@media (min-width: 768px) {
  .table-responsive {
    overflow: hidden !important;
  }
}
</style>
